import { render, staticRenderFns } from "./PageEdit.vue?vue&type=template&id=68fff120&"
import script from "./PageEdit.vue?vue&type=script&lang=ts&"
export * from "./PageEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports